// extracted by mini-css-extract-plugin
export default {"wrapper":"Xz-z","viewport":"Yz-z","container":"Zz-z","slide":"_z-z"};